import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"
import Sidebar from "./Sidebar"
import { useEffect, useState } from "preact/hooks"
import { debounce } from "../helpers"

export function CategoryBody({ loading, foundProducts, isChecked, setIsChecked, isVisible }) {
   

    if (loading) return <Loader />
    return (
        foundProducts ? <>
            <div class={`ns-top-container ${!isVisible ? 'sticky' : ''}`}>
                <Toolbar isChecked={isChecked} />
                <Sidebar isChecked={isChecked} setIsChecked={setIsChecked}/>
                <SelectedFilters />
            </div>
            <Products />
            <BottomToolbar />
        </> : <NoResults />
    )
}

export function CategoryBodyInfiniteScroll({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <SelectedFilters />
            <Toolbar />
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("category", CategoryBodyInfiniteScroll)
export default wrapContent("category", CategoryBody)
